import group from "./undo_group";
import {find, findIndex} from "../helpers/array";

export const lockCss = "webix_lock";

export function init(view){
	view._locks = {};
	view.attachEvent("onReset", () => reset(view));
	view.attachEvent("onUndo", (type, row, column, mode) => {
		if (type === "lock") lockCell(view, row, column, !!mode, true);
	});
	view.attachEvent("onCommand", (cm) => {
		if (cm.id === "lock-cell")
			lock(view);
	});
	view.attachEvent("onAction", (action, p)=> {
		if(action == "before-grid-change")
			updatePosition(view, p.name, p.inc, p.data, p.start);
	});
}

function reset(view){
	view._locks = {};
}

export function lockCell(view, row, column, mode, silent, pageName, innerCall){
	const activeSheet = view.getActiveSheet();
	if(!pageName)
		pageName = activeSheet;

	const table = view.$$("cells");
	if (typeof row === "object" && typeof column === "object"){
		group.set(function() {
			_mapCellsCalls(row, column, function(row, column){
				lockCell(view, row, column, mode, true, pageName, true);
			});
		});
	} else {
		mode = ((mode === false) ? false : true);
		if(pageName == activeSheet){
			const objrow = view._locks[row] = view._locks[row] || {};
			objrow[column] = mode;
			if (mode)
				table.addCellCss(row, column, lockCss, true);
			else
				table.removeCellCss(row, column, lockCss, true);
		}
		else{
			const page = find(view._sheets, sheet => sheet.name == pageName);
			if(page){
				const locked = page.content.locked; 
				if(locked){
					const locked = page.content.locked;
					const index = findIndex(locked, cell => cell[0] == row && cell[1] == column);
					if(mode){
						if(index == -1)
							locked.push([row, column]);
					}
					else if(index != -1)
						locked.splice(index, 1);
				}
				else if(!locked && mode)
					page.content.locked = [[row, column]];
			}
		}
	}

	if(!innerCall)
		view.callEvent("onAction", ["lock", { row, column, value: !mode, newValue: mode }]);

	if (!silent)
		table.refresh();
}

function _mapCellsCalls(start, end, handler, master){
	for (let x = start.row; x <= end.row; x++)
		for (let y = start.column; y <= end.column; y++)
			handler.call(master||this, x, y);
}

export function isCellLocked(view, row, column, page){
	if(!page || page == view.getActiveSheet())
		return view._locks[row]?(view._locks[row][column]||false):false;
	else{
		page = find(view._sheets, sheet => sheet.name == page);
		if(page && page.content.locked)
			return !!find(page.content.locked, cell => cell[0] == row && cell[1] == column);
		return false;
	}
}

export function serialize(view,data){
	const locked = [];
	for(let row in view._locks){
		for(let column in view._locks[row])
			if(view._locks[row][column])
				locked.push([row,column]);
	}
	data.locked = locked;
}

export function load(view,data){
	const locked = data.locked;
	if(locked)
		for(let i = 0; i < locked.length; i++)
			lockCell(view, locked[i][0],locked[i][1], true, true);
}

function lock(view){
	const block = view.$$("cells").getSelectArea();
	if (block){
		const mode = view.isCellLocked(block.start.row, block.start.column);
		view.lockCell(block.start, block.end, !mode);
	}
}

function updatePosition(view, name, inc, data, start){
	let locked = data.locked,
		i = locked.length;

	if(inc){
		while(i--){
			let [row,column] = locked[i];
			if(row && name == "row" && row >= start.row || column && name == "column" && column >= start.column){
				if (name == "row"){
					if (row < start.row - inc)	//delete lock mark if row was deleted
						locked.splice(i,1);
					else						//update mark position if upper row was deleted
						locked[i][0] = row*1 + inc;
				} else if (name == "column"){
					if (column < start.column - inc){
						locked.splice(i, 1);
					} else 
						locked[i][1] = column*1 + inc;
				}
			}
		}
	}
}